import React, { useState, useEffect, useRef } from 'react';

const ImageCardModel = ({ files, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const mediaRef = useRef(null);

  const currentFile = files && files.length > 0 ? files[0] : null;

  const isVideo = (file) => {
    if (!file) return false;
    const videoExtensions = ['mp4', 'webm', 'ogg'];
    const extension = file.split('.').pop().toLowerCase();
    return videoExtensions.includes(extension);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (mediaRef.current) {
      observer.observe(mediaRef.current);
    }

    return () => {
      if (mediaRef.current) {
        observer.unobserve(mediaRef.current);
      }
    };
  }, []);

  return (
    <div className={`relative ${className}`} ref={mediaRef}>
      {!currentFile ? (
        <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 rounded-3xl flex items-center justify-center">
          <span className="text-gray-500 text-sm">No image</span>
        </div>
      ) : isVideo(currentFile) ? (
        isVisible && (
          <video
            className="w-full h-full object-cover rounded-3xl"
            muted
            autoPlay
            loop
            playsInline
            loading="lazy"
          >
            <source src={currentFile} type={`video/${currentFile.split('.').pop().toLowerCase()}`} />
            Your browser does not support the video tag.
          </video>
        )
      ) : (
        <div
          className={`bg-cover bg-center h-full w-full rounded-3xl ${
            imageLoaded && isVisible ? 'opacity-100' : 'opacity-0'
          } transition-opacity duration-500`}
        >
          {isVisible && (
            <img
              src={currentFile}
              alt="Model"
              className="w-full h-full object-cover rounded-3xl"
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
              style={{ opacity: imageLoaded ? 1 : 0 }}
            />
          )}
          {(!isVisible || !imageLoaded) && (
            <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
              <div className="flex flex-col items-center">
                <div className="w-8 h-8 border-4 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                <span className="text-gray-500 mt-2 text-sm">Loading...</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageCardModel;